var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4 1.4V8.13148C2.08297 8.32799 2.77143 8.27659 3.50772 8.06725C4.34485 7.82924 5.18762 7.40565 6.11828 6.93789L6.11831 6.93787L6.11832 6.93787L6.11853 6.93776L6.119 6.93752C6.22763 6.88293 6.33746 6.82773 6.44861 6.77215C8.2181 5.88742 10.2997 4.91235 12.6 5.60918V1.4H1.4ZM1.4 12.6V9.57037C2.25741 9.73727 3.09227 9.64085 3.89059 9.41388C4.86448 9.13699 5.83278 8.64937 6.74262 8.19119L6.74407 8.19046L6.74409 8.19045C6.8552 8.1345 6.96543 8.07898 7.0747 8.02435C9.01556 7.05393 10.7339 6.32472 12.6 7.09456V12.6H1.4ZM1 0C0.447715 0 0 0.447716 0 1V13C0 13.5523 0.447716 14 1 14H13C13.5523 14 14 13.5523 14 13V1C14 0.447715 13.5523 0 13 0H1ZM3.6819 4.13645C3.6819 3.88541 3.88541 3.6819 4.13645 3.6819C4.38749 3.6819 4.59099 3.88541 4.59099 4.13645C4.59099 4.38749 4.38749 4.59099 4.13645 4.59099C3.88541 4.59099 3.6819 4.38749 3.6819 4.13645ZM4.13645 2.6819C3.33312 2.6819 2.6819 3.33312 2.6819 4.13645C2.6819 4.93977 3.33312 5.59099 4.13645 5.59099C4.93977 5.59099 5.59099 4.93977 5.59099 4.13645C5.59099 3.33312 4.93977 2.6819 4.13645 2.6819Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageFile);
export default __webpack_public_path__ + "static/media/icon_image_file.fc5b8798630e4f50fc81f30ca37cca31.svg";
export { ForwardRef as ReactComponent };